// extracted by mini-css-extract-plugin
export default {"root":"A8_2p","expanded":"oUQQr"};